module.exports = __webpack_public_path__ + "media/images/ratae-star-cf58eae7391a97560083890ed81d5970.svg";